import { render, staticRenderFns } from "./dynamicCrad.vue?vue&type=template&id=30590161&scoped=true"
import script from "./dynamicCrad.vue?vue&type=script&lang=js"
export * from "./dynamicCrad.vue?vue&type=script&lang=js"
import style0 from "./dynamicCrad.vue?vue&type=style&index=0&id=30590161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30590161",
  null
  
)

export default component.exports